import { render, staticRenderFns } from "./Partenaires.vue?vue&type=template&id=8ab35238&scoped=true&"
import script from "./Partenaires.vue?vue&type=script&lang=js&"
export * from "./Partenaires.vue?vue&type=script&lang=js&"
import style0 from "./Partenaires.vue?vue&type=style&index=0&id=8ab35238&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab35238",
  null
  
)

export default component.exports